let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5xh5m")).then(() => parcelRequire('dT2Su'));